// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
export default {
  fetch(lastmodified) {
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/categories/history`, {
    //       params: { lastmodified }
    //     })
    //     .then((response) => response.data)
    // );
  }
};



// WEBPACK FOOTER //
// ./src/entities/category/category-history/category-history-full/category-history-full-service.js